import { Tooltip } from "@mui/material"
import { StyledItem } from "./styled"
import { IItemProps } from "./types"
import { Typography } from "../../../basics"
import { useSidebarStore } from "src/store/sidebarStore"
import { useIsMobile } from "src/lib/hooks/useIsMobile"

const Item = ({ icon, label, selected, onClick, ...props }: IItemProps) => {
    const open = useSidebarStore((s: any) => s.open)
    const setMobileOpen = useSidebarStore((s: any) => s.setMobileOpen)
    const isMobile = useIsMobile()

    // no mobile a sidebar é um overlay sempre expandido
    const expanded = isMobile || open

    const handleClick = () => {
        onClick?.()
        if (isMobile) setMobileOpen(false)
    }

    const button = (
        <StyledItem selected={selected} open={expanded} onClick={handleClick} {...props}>
            {icon}
            {expanded && (
                <Typography
                    variant="body1"
                    sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: "inherit", fontWeight: "inherit" }}
                >
                    {label}
                </Typography>
            )}
        </StyledItem>
    )

    if (expanded) return button

    return (
        <Tooltip title={label} placement="right">
            {button}
        </Tooltip>
    )
}

export { Item }
